// Angular
import { Injectable } from '@angular/core';

// Libraries
import { MatDrawer } from '@angular/material/sidenav';

// Models
import { AppCleanup, DrawerModel } from '../models';
import { Select } from '@ngxs/store';
import { StorageState } from '../state/storage.state';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class DrawerService extends AppCleanup {
	// Comment drawer on Job Overview page
	@Select(StorageState.commentDrawerSettings) commentDrawerSettings$: Observable<DrawerModel>;
	commentDrawer: MatDrawer; // Comment drawer element
	commentDrawerSettings: DrawerModel;

	@Select(StorageState.modelDrawerSettings) modelDrawerSettings$: Observable<DrawerModel>;
	modelDrawer: MatDrawer; // Comment drawer element
	modelDrawerSettings: DrawerModel;

	constructor() {
		super();
	}

	setCommentDrawer(drawer: MatDrawer) {
		this.commentDrawer = drawer;
	}

	changeCommentDrawerMode() {}

	openCommentDrawer() {
		this.commentDrawer?.open();
	}

	closeCommentDrawer() {
		this.commentDrawer?.close();
	}

	toggleCommentDrawer() {
		this.commentDrawer?.toggle();
	}

	setModelDrawer(drawer: MatDrawer) {
		this.modelDrawer = drawer;
	}

	changeModelDrawerMode() {}

	openModelDrawer() {
		this.modelDrawer.open();
	}

	closeModelDrawer() {
		this.modelDrawer.close();
	}

	toggleModelDrawer() {
		this.modelDrawer.toggle();
	}
}
